
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/virtual-accounts/payouts",
      function () {
        return require("private-next-pages/docs/payment-initiation/virtual-accounts/payouts.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/virtual-accounts/payouts"])
      });
    }
  